import React, { Component } from 'react';
import './index.less';
import { getMultiLang } from '@platform/api';
import SmallCard from './SmallCard';
import LargeCard from './LargeCard';
import { splitPks } from '../utils';
import { connect, usePagination, useCheckbox, useRowClick, useStore } from "@platform/table-core";

let hookExtensions = [ connect, useStore, useCheckbox, usePagination, useRowClick ];
const ComposedSmallCard = hookExtensions.reduceRight((Table, HOC) => HOC(Table), SmallCard);
const ComposedLargeCard = hookExtensions.reduceRight((Table, HOC) => HOC(Table), LargeCard);

class GridTable extends Component {
    componentDidMount() {
        this.props.store.setRef(this);

        let { store } = this.props;

        getMultiLang({
            moduleId: "page_table",
            callback: json => {
                store.setLocale(json);
            },
        });
    }

    render() {
        let {
                type = 'small',
                store,
                dataSource,
                onSelected,
                onSelectedAll,
                selectedChange,
                onRowClick,
                onRowDoubleClick,
                pageScope,
                showPagination,
                paginationExtendRender,
                handlePageInfoChange,
                config,
                id,
            } = this.props,
            Component = type === 'small' ? ComposedSmallCard : ComposedLargeCard;

        return <Component
            {...this.props}
            gridTable
            checkboxConfig={{
                enable: false,
                onCheck: (rowKey, { isChecked, checkedKeys, lastCheckedKeys }) => {
                    let visibleKeysLength = store.getVisibleRowKeys()?.length || 0;
                    if(store.getConfig()?.tableId){
                        dataSource?.[store.getConfig()?.tableId].setCheckedKeys(checkedKeys);
                    }
                    if(rowKey){ //单行改变
                        let row = store.getRowData(rowKey);
                        onSelected?.(
                            { ...pageScope.props, ...pageScope.output },
                            id,
                            row,
                            row.dataIndex,
                            isChecked,
                            //TODO isUnique
                        );
                    } else {
                        onSelectedAll?.(
                            { ...pageScope.props, ...pageScope.output },
                            id,
                            !!checkedKeys?.size,
                            visibleKeysLength,
                        );
                    }

                    selectedChange?.({ ...pageScope.props, ...pageScope.output }, id, checkedKeys?.size || 0, lastCheckedKeys?.size || 0);

                },
            }}
            rowProps={row => {
                return {
                    onClick:  e => onRowClick?.({ ...pageScope.props, ...pageScope.output }, id, row, store.getRowData(row.key).dataIndex, e),
                    onDoubleClick: onRowDoubleClick && (e => onRowDoubleClick?.(row, store.getRowData(row.key).dataIndex, { ...pageScope.props, ...pageScope.output }, e)),
                };
            }}
            paginationConfig={{
                enable: showPagination && store.getStatus() !== 'edit',
                paginationExtendRender: paginationExtendRender,
                onChange: ({ pageIndex, pageSize }) => {
                    let allPks = store.getAllRowsInfo()?.allpks;
                    let pks = splitPks(allPks, pageIndex, pageSize);
                    handlePageInfoChange?.({ ...pageScope.output, ...pageScope.props }, config, pks, store.getPaginationInfo()?.total, { tableId: id });
                },
            }}
        />;
    }
}

export default GridTable;
